<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :height="size"
    :width="size"
    :viewBox="'0 0 ' + size + ' ' + size"
    :class="cssClass"
    @click="click"
  >
    <use :xlink:href="require('@/assets/img/sprite.svg') + '#' + variant" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      required: false
    },
    size: {
      type: [Number, String],
      required: false,
      default: 14
    },
    variant: {
      type: String,
      required: false
    }
  },
  computed: {
    cssClass() {
      return {
        'c-icon': true,
        ['c-icon--' + this.color]: this.color,
        ['c-icon--' + this.variant]: this.variant
      };
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    }
  }
};
</script>
